/***********************************************
ICEMEDX - Developed By ICEMEDX, Inc.
Copyright 2019 ICEMEDX, Inc.
***********************************************/
import { Injectable } from '@angular/core';
import { IceEntity } from '../../core/IceEntity';
import { IceTypes } from '../../icetypes';

export class requestvalidation extends IceEntity {
  request_validation_key: string = "";
  valid_request_indicator: boolean = false;
  reject_reason_code: string = "";
  followup_action_code: string = "";
  record_version: number = 0;
  offline_record_status: number = 0;

  gettablename(): string {
    return "REQUEST_VALIDATION";
  }
}
